import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const BASE_PATH = "/bo/api-keys";
const PERMISSION_CATALOG_CACHE_TTL_MS = 5 * 60 * 1000;

const actions = {
    async listApiKeys({ commit, dispatch }) {
        try {
            const { data } = await Http.instance.get(BASE_PATH);
            return data.items;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_API_KEYS", parseError);
            throw parseError;
        }
    },
    async createApiKey(
        { commit, dispatch },
        { expiresInDays, name, permissions }
    ) {
        try {
            const { data } = await Http.instance.post(BASE_PATH, {
                name,
                expiresInDays,
                permissions
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_API_KEYS", parseError);
            throw parseError;
        }
    },
    async getApiKeyPermissionCatalog({ commit, dispatch }) {
        try {
            const { data } = await Http.instance.get(
                `${BASE_PATH}/permissions`
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_API_KEYS", parseError);
            throw parseError;
        }
    },
    async ensureApiKeyPermissionCatalog({
        commit,
        dispatch,
        getters,
        rootState,
        state
    }) {
        if (getters.isPermissionCatalogCacheValid) {
            return state.permissionCatalog.data.groups || [];
        }
        const data = await dispatch("getApiKeyPermissionCatalog");
        commit("SET_API_KEY_PERMISSION_CATALOG", {
            data,
            tenantId: rootState.auth.tenantId,
            expiredAt: Date.now() + PERMISSION_CATALOG_CACHE_TTL_MS
        });
        return (data && data.groups) || [];
    },
    async revokeApiKey({ commit, dispatch }, { id }) {
        try {
            await Http.instance.delete(`${BASE_PATH}/${id}`);
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_API_KEYS", parseError);
            throw parseError;
        }
    }
};

export default actions;
